import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'boards',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change([])
  }
}
